import React from 'react';
import propTypes from 'prop-types';
import {findIndex} from 'lodash';
import styled from '@emotion/styled';
import {ReactSVG} from 'react-svg';

import {theme} from '../../../themes/default-theme';
import tickWhite from '../../../assets/icons/check-white.svg';
import {RespImg} from '../../../components/ui';
import Text from '../../../components/typography';

const ThumbnailItem = styled.div`
  cursor: pointer;

  img,
  picture {
    overflow: hidden;
  }
`

const ThumbnailTitle =  styled.div`
  margin-top: 20px;
`

const ThumbnailContent = styled.div`
  ${props => props.featured === 1 && `
    width: 50%;
    text-align: left;

    ${theme.breakpoints.down('xs')} {
      width: 100%;
      text-align: center;
      p,
      h6 {
        text-align: center;
      }
    }
  `}
`

const ThumbnailWrapper = styled.div`
  margin: 0 auto;
  position: relative;

  ${theme.breakpoints.down('sm')} {
    max-width: 100%;
  }

`

const ThumbnailContainer = styled.div`;
  transition: opacity 200ms ease;
  opacity: 1;

  ${props => props.active === 1 && `
    opacity: 0.5;
  `}

`

const Tick = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 12px;
  border-radius: 50px;
  opacity: 0;
  transition: all 200ms ease;
  transform: scale(0,0);
  background-color: ${theme.palette.skyBlue};
  z-index: 1;

  ${props => props.display === 1 && `
    opacity: 1;
    transform: scale(1,1);
  `}

  svg {
    width: 12px;
    height: 12px;
    display: block;
  }
`

const TitleContent = styled.div `
  font-size: 14px;

  ${theme.breakpoints.up('md')} {
    font-size: 14px;
  }
`

const CheckThumbnail = ({image, title, active}) => {
  return (
    <ThumbnailItem>
      <ThumbnailWrapper>
        <Tick display={active ? 1 : 0}>
          <ReactSVG src={tickWhite} />
        </Tick>
        <ThumbnailContainer active={active ? 1 : 0}>
          <RespImg 
            {...image}
          />
          <ThumbnailContent>
            <ThumbnailTitle>
              <Text variant="h6" align={'center'} uppercase colour={'charcoal'}>
                <TitleContent>{title}</TitleContent>
              </Text>
            </ThumbnailTitle>
          </ThumbnailContent>
        </ThumbnailContainer>
      </ThumbnailWrapper>
    </ThumbnailItem>
  )
}

CheckThumbnail.propTypes = {
}

export default CheckThumbnail